import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import "./i18n";
import "./date-setup";
import App from "./App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import starWebPRNTService from "./services/starWebPRNTService";

const queryClient = new QueryClient();
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Service Worker登録（PWAオフライン対応）
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // 新バージョンが利用可能になった場合、自動でアクティベート
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

// 印刷キューのリトライタイマーを開始（失敗した印刷を定期的にリトライ）
starWebPRNTService.startPrintQueueRetry();
